const taskIdentifierLabel = Object.freeze({
  segment_export_devices: 'TaskHistoryList_ExportSegmentDevices',
  segment_shared_export_devices: 'TaskHistoryList_ExportSegmentDevices',
  segment_export_profiles: 'TaskHistoryList_ExportSegmentProfiles',
  segment_shared_export_profiles: 'TaskHistoryList_ExportSegmentProfiles',
  export_campaign_engagement: 'TaskHistoryList_ExportCampaignEngagement',
  export_campaign_engagement_date_range:
    'TaskHistoryList_ExportCampaignEngagementDateRange',
  external_audience_integration_export: 'TaskHistoryList_ExportSegmentProfiles',
  segment_count_recipients: 'TaskHistoryList_SegmentRecipientsCount',
  segment_count_channels: 'TaskHistoryList_SegmentChannelsCount',
  segment_count_profiles: 'TaskHistoryList_SegmentProfilesCount',
  segment_count_devices: 'TaskHistoryList_SegmentDevicesCount',
  segment_preview_recipients: 'TaskHistoryList_SegmentRecipientsPreview',
  campaign_count_recipients: 'TaskHistoryList_CampaignRecipientsCount',
  throttled_campaign_prepare_recipients:
    'TaskHistoryList_ThrottledCampaignRecipientsPrepare',
  campaign_preview_recipients: 'TaskHistoryList_CampaignPreviewRecipients',
  campaign_stop_all: 'TaskHistoryList_CampaignStopAll',
  google_ads_audiences_sync: 'TaskHistoryList_GoogleAdsAudienceSync',
  message_export_campaign: 'TaskHistoryList_ExportCampaignMessages',
  campaign_report_workflow_export_engagement:
    'TaskHistoryList_ExportCampaignReportWorkflowEngagement',
  workflow_export_engagement: 'TaskHistoryList_ExportWorkflowEngagement',
  campaign_report_workflow_export_currently_waiting:
    'TaskHistoryList_ExportCampaignReportCurrentlyWaiting',
  workflow_export_currently_waiting:
    'TaskHistoryList_ExportWorkflowCurrentlyWaiting',
  message_export_campaign_failed:
    'TaskHistoryList_ExportCampaignMessagesFailed',
  message_export_send: 'TaskHistoryList_ExportSendMessages',
  inbox_feed_expiry: 'TaskHistoryList_InboxFeedExpiry',
  list_import: 'TaskHistoryList_UserListImport',
  list_export: 'TaskHistoryList_UserListExport',
  profile_attribute_create_index: 'TaskHistoryList_ProfileAttributeCreateIndex',
  profile_attribute_remove: 'TaskHistoryList_ProfileAttributeRemove',
  profile_attributes_remove: 'TaskHistoryList_ProfileAttributesRemove',
  profile_aggregates_remove: 'TaskHistoryList_ProfileAggregatesRemove',
  profile_import: 'TaskHistoryList_ProfileImport',
  profile_export_data: 'TaskHistoryList_ExportProfileData',
  profile_delete_personal_data: 'TaskHistoryList_DeletePersonalData',
  event_import: 'TaskHistoryList_EventImport',
  device_delete_personal_data: 'TaskHistoryList_DeleteDevicePersonalData',
  active_directory_profiles_sync: 'TaskHistoryList_ActiveDirectoryProfilesSync',
  active_directory_lists_sync: 'TaskHistoryList_ActiveDirectoryListsSync',
  kochava_sync_installs: 'TaskHistoryList_KochavaSyncInstalls',
  alira_sync_groups: 'TaskHistoryList_AliraSyncGroups',
  meta_audiences_sync: 'TaskHistoryList_MetaAudienceSync',
  magento_create_attributes: 'TaskHistoryList_MagentoCreateAttributes',
  microsite_export_form_submissions:
    'TaskHistoryList_MicrositeExportFormSubmissions',
  optimove_campaign_execute: 'TaskHistoryList_OptimoveCampaignExecute',
  optimove_campaign_pre_execute: 'TaskHistoryList_OptimoveCampaignPreExecute',
  optimove_attributes_sync: 'TaskHistoryList_OptimoveAttributesSync',
  optimove_suppression_attributes_sync:
    'TaskHistoryList_OptimoveCustomAttributesSync',
  optimove_suppression_attributes_import:
    'TaskHistoryList_OptimoveCustomAttributesImport',
  optimove_list_update: 'TaskHistoryList_OptimoveListUpdate',
  sbtech_promotions_sync: 'TaskHistoryList_SbtechPromotionsSync',
  dynamic_promotions_sync: 'TaskHistoryList_DynamicPromotionsSync',
  lithium_promotions_sync: 'TaskHistoryList_LithiumPromotionsSync',
  lithium_v2_promotions_sync: 'TaskHistoryList_LithiumV2PromotionsSync',
  tglab_promotions_sync: 'TaskHistoryList_TgLabPromotionsSync',
  warply_couponsets_sync: 'TaskHistoryList_WarplySyncCouponsets',
  cleanup_users: 'TaskHistoryList_CleanupUsers',
  fs_import_automation: 'TaskHistoryList_ImportData',
  shopify_sync_data: 'TaskHistoryList_ShopifySyncData',
  shopify_fetch_profile_data: 'TaskHistoryList_ShopifyFetchProfileData',
  shopify_fetch_purchase_data: 'TaskHistoryList_ShopifyFetchPurchaseData',
  shopify_sync_webhooks: 'TaskHistoryList_ShopifySyncWebhooks',
  shopify_create_attributes: 'TaskHistoryList_ShopifyCreateAttributes',
  tag_remove: 'TaskHistoryList_TagRemove',
  mixpanel_handle_cohort_request: 'TaskHistoryList_MixpanelCohortAction',
  magento_fetch_profile_data: 'TaskHistoryList_MagentoFetchProfileData',
  magento_fetch_purchase_data: 'TaskHistoryList_MagentoFetchPurchaseData',
  metabase_compute_all: 'TaskHistoryList_MetabaseComputeAll',
  metabase_compute_card: 'TaskHistoryList_MetabaseComputeCard',
  sf_profile_sync: 'TaskHistoryList_SFSyncProfileSubscriptionFlags',
  sf_messaging_events_sync: 'TaskHistoryList_SFMessagingEventsSync',
  audit_log_clean_up: 'TaskHistoryList_AuditLogCleanUp',
  campaign_audit_log_clean_up: 'TaskHistoryList_CampaignAuditLogCleanUp',
  segment_rolling_sync: 'TaskHistoryList_SegmentRollingSync',
  segment_rolling_delete: 'TaskHistoryList_SegmentRollingDelete',
  generate_send_report: 'TaskHistoryList_GenerateSendReport',
  delayed_trigger_campaign: 'TaskHistoryList_DelayedTriggerCampaign',
  attribute_convert_type: 'TaskHistoryList_AttributeConvertType',
  delete_event_data: 'TaskHistoryList_EventDataDelete',
  mlstudio_prediction_results_import:
    'TaskHistoryList_MlstudioPredictionResultsImport',
  export_consent_preferences: 'TaskHistoryList_ExportConsentPreferences',
  export_otp_history: 'TaskHistoryList_ExportOTPHistory',
  workflow_migration: 'TaskHistoryList_WorkflowMigration',
  subscription_change_task: 'TaskHistoryList_SubscriptionChangeTask',
  export_campaign_analytics: 'TaskHistoryList_ExportCampaignAnalytics'
})
const evaluateTaskIdentifierLabel = Object.freeze({
  segment_export_devices: 'TaskHistoryList_ExportSegmentDevices',
  segment_shared_export_devices: 'TaskHistoryList_ExportSegmentDevices',
  segment_export_profiles: 'TaskHistoryList_ExportSegmentProfiles',
  segment_shared_export_profiles: 'TaskHistoryList_ExportSegmentProfiles',
  segment_count_recipients: 'TaskHistoryList_SegmentRecipientsCount',
  segment_count_channels: 'TaskHistoryList_SegmentChannelsCount',
  segment_count_profiles: 'TaskHistoryList_SegmentProfilesCount',
  segment_count_devices: 'TaskHistoryList_SegmentDevicesCount',
  segment_preview_recipients: 'TaskHistoryList_SegmentRecipientsPreview'
})

const evaluateRollingSegmentTaskIdentifierLabel = Object.freeze({
  ...evaluateTaskIdentifierLabel,
  segment_rolling_sync: 'TaskHistoryList_SegmentRollingSync'
})

const taskStatusEnum = Object.freeze({
  NEW: 0,
  EXECUTING: 1,
  DONE: 2,
  ERROR: 3,
  FATAL: 4
})

const taskStatusLabel = Object.freeze({
  0: 'TaskHistoryList_Status_New',
  1: 'TaskHistoryList_Status_Executing',
  2: 'TaskHistoryList_Status_Complete',
  3: 'TaskHistoryList_Status_Error',
  4: 'TaskHistoryList_Status_Fatal'
})

export {
  taskStatusEnum,
  taskIdentifierLabel,
  taskStatusLabel,
  evaluateTaskIdentifierLabel,
  evaluateRollingSegmentTaskIdentifierLabel
}



// WEBPACK FOOTER //
// ./src/modules/tasks/enum/TaskRecordEnums.js